export const getInitialAppStudioModel = () => (window as any).appStudioModel;

export const isAppStudio = () => getInitialAppStudioModel() !== undefined;
